<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/insbill/index"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
        :paramsCepCallback="paramsCepCallback"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="handleRow(row, 'detail')"
            >详情</el-button
          >
          <el-button
            v-if="row.status <= 1"
            type="text"
            size="mini"
            @click="handleRow(row, 'edit')"
            >编辑</el-button
          >
          <el-button
            v-if="row.status === 3"
            type="text"
            size="mini"
            @click="handleRow(row, 'withdraw')"
            >撤回</el-button
          >
          <el-button
            v-if="row.status === 6"
            type="text"
            size="mini"
            @click="handleRow(row, 'cancellation')"
            >作废</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="handleRow(row, 'del')"
            >删除</el-button
          >
          <el-button
            v-if="row.status === 6"
            type="text"
            size="mini"
            @click="handleRow(row, 'electronic')"
            >电子单</el-button
          >
		  <el-button
		    v-if="row.status === 6"
		    type="text"
		    size="mini"
		    @click="handleRow(row, 'finance')"
		    >财务补录</el-button
		  >
		  <el-button
		    v-if="row.status === 6"
		    type="text"
		    size="mini"
		    @click="handleRow(row, 'contract')"
		    >电子合同</el-button
		  >
		  <el-button
		    v-if="row.status === 6"
		    type="text"
		    size="mini"
		    @click="handleRow(row, 'term')"
		    >修改条款</el-button
		  >
		  <el-button
		    v-if="row.status === 6"
		    type="text"
		    size="mini"
		    @click="handleRow(row, 'supplement')"
		    >附件补录</el-button
		  >
		  <el-button
		    v-if="row.status === 6"
		    type="text"
		    size="mini"
		    @click="handleRow(row, 'sendSms')"
		    >发送短信</el-button
		  >
        </template>
      </BaseTable>
	  <el-dialog
	    :title="dialogTitle"
	    :visible.sync="dialogVisible"
	    width="30%"
	    @close="dialogClosed"
	  >
	    <BaseForm
	      ref="baseForm"
	      v-model="formData"
	      :formOptions="cashFormOption"
	      labelWidth="120px"
	    >
		<el-form-item label="收款方式" prop="receiptType">
		  <el-select
		    v-model="formData.receiptType"
		    placeholder="请选择收款方式"
		    filterable
		  >
		    <el-option
		      v-for="item in $store.state.app.receiptType"
		      :key="item.label"
		      :label="item.label"
		      :value="item.value"
		    ></el-option>
		  </el-select>
		</el-form-item>
	    </BaseForm>
	    <span slot="footer" class="dialog-footer">
	      <el-button size="small" @click="dialogVisible = false"
	        >取 消</el-button
	      >
	      <el-button size="small" type="primary" @click="handleSubmit"
	        >确 定</el-button
	      >
	    </span>
	  </el-dialog>
	  <!-- 修改条款 -->
	  <el-dialog
	    title="修改服务条款"
	    :visible.sync="dialogTermVisible"
	    width="30%"
	    @close="dialogTermVisible = false"
	  >
	    <BaseForm 
		ref="baseTermForm"
		:formOptions="[]"
		>
			<el-form-item label="流水号:">
				{{ termData.insBillId }}
			</el-form-item>
			<el-form-item label="单号:">
				{{ termData.bh }}
			</el-form-item>
	  		<el-form-item label="服务条款:" prop="term">
	  		  <el-select
	  		    v-model="termData.term"
	  		    placeholder="请选择服务条款"
	  		    filterable
	  		  >
	  		    <el-option
	  		      v-for="item in term"
	  		      :key="item.id"
	  		      :label="item.title"
	  		      :value="item.id"
	  		    ></el-option>
	  		  </el-select>
	  		</el-form-item>
	    </BaseForm>
	    <span slot="footer" class="dialog-footer">
	      <el-button size="small" @click="dialogTermVisible = false"
	        >取 消</el-button
	      >
	      <el-button size="small" type="primary" @click="handleTermSubmit"
	        >确 定</el-button
	      >
	    </span>
	  </el-dialog>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { cashFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Search",
  comments: {},
  data() {
    return {
      tableData: [],
      orgOption: [],
      searchData: {
		keyword: '',
        dateList: [],
      },
	  // 弹框相关
	  dialogTitle: "",
	  dialogVisible: false,
	  dialogTermVisible: false,
	  // 表单相关
	  formData: [],
	  termData: [],
	  term: [],
	  creatorNoList: [],
    };
  },
  computed: {
    columns,
    searchFormOption,
	cashFormOption,
  },
  created() {
	  this.$store.dispatch("app/getReceiptType");
	  // 获取服务条款
	  this.getTerm();
	  this.CreatorNoList();
	  const { vin } = this.$route.query;
	  if(vin){
		 this.searchData.keyword = vin;
	  }
  },
  methods: {
    add() {},
	// 获取服务条款
	async getTerm() {
		this.$api.post("/admin/carHeTong/getTerm", {}).then((res) => {
			if(res.data.data){
				this.term = res.data.data;
			}
		});
	},
	CreatorNoList() {
	  this.$api.post("/admin/admin/getCreatorNo", {}).then((res) => {
	    this.creatorNoList = res.data;
	  });
	},
    handleRow(row, k) {
      switch (k) {
        case "detail":
          this.$router.push({
            path: "/issue/detail",
            query: {
              insBillId: row.insBillId,
            },
          });
          break;
        case "edit":
          this.handleEdit(row);
          break;
        case "electronic":
          this.handleElectronic(row);
          break;
        case "withdraw":
          this.handleWithdraw(row);
          break;
        case "cancellation":
          this.handleCancellation(row);
          break;
        case "del":
          this.handleDel(row);
          break;
		case "finance":
			this.handleFinance(row);
			break;
		case "contract":
			this.handleContract(row);
			break;
		case "term":
			this.handleTerm(row);
			break;
		case "supplement":
			this.$router.push({
			  path: "/issue/detail",
			  query: {
				insBillId: row.insBillId,
				supplement:'supplement'
			  },
			});
		break;
		case "sendSms":
			this.$confirm(`是否确认发送短信?`, "提示", {
			  confirmButtonText: "确定",
			  cancelButtonText: "取消",
			  type: "warning",
			})
			  .then(async () => {
			    await this.$api.post(
			      "/admin/customer/sendSms",
			      { vin: row.vin,insbillId: row.insBillId },
			      "发送"
			    );
			    this.handleSearch();
			  })
			  .catch(() => {
			    this.$message({
			      type: "info",
			      message: "已取消操作",
			    });
			  });
			break;
        default:
          break;
      }
    },
    // 点击编辑
    handleEdit({ insBillId }) {
      this.$router.push({
        path: "/issue/recording",
        query: {
          insBillId,
        },
      });
    },
    // 点击撤回
    handleWithdraw({ insBillId }) {
      this.$confirm(`是否确认撤回【${insBillId}】服务单, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post(
            "/admin/insbill/withdraw",
            { bill_id: insBillId },
            "撤回"
          );
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 点击电子单
    async handleElectronic({ url }) {
		console.log(url)
      if (!url) {
        this.$message.warning("暂无电子单");
        return;
      }
      window.open(url);
    },
    // 点击作废
    handleCancellation({ insBillId }) {
      this.$confirm(`是否确认作废【${insBillId}】服务单, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post(
            "/admin/insbill/cancel",
            { bill_id: insBillId },
            "作废"
          );
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 点击删除
    handleDel({ insBillId }) {
      this.$confirm(`是否确认删除【${insBillId}】服务单, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.post(
            "/admin/insbill/delInsBill",
            { insBillId: insBillId },
            "删除"
          );
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
	// 点击财务补录
	handleFinance(row) {
	  this.dialogTitle = `财务补录(${row.insBillId})`;
	  this.dialogVisible = true;
	  this.formData = {
	    ...this.formData,
	    ...row,
	  };
	},
	// 点击查看电子合同
	handleContract(row) {
	  this.$api.post("/admin/carHeTong/getUserContract", {insBillId: row.insBillId}).then((res) => {
	  	if(res.status == 10001){
	  		this.$message.warning(res.message);
	  	}
		window.open(res.data.front_path);
	  });
	},
	// 点击修改条款
	handleTerm(row) {
		this.termData = {
			insBillId: row.insBillId,
			bh: row.bh,
			term: row.term
		}
	  this.dialogTermVisible = true;
	},
	// 弹框关闭
	dialogClosed() {
	  this.$refs.baseForm.resetFields();
	},
	// 提交
	handleSubmit() {
	  this.$refs.baseForm.onSubmit((validate) => {
	    if (validate) {
	      this.$confirm("是否确认提交, 是否继续?", "提示", {
	        confirmButtonText: "确定",
	        cancelButtonText: "取消",
	        type: "warning",
	      })
	        .then(async () => {
	          await this.$api.post(
	            "/admin/insBill/supplement",
	            {
					'insBillId':this.formData.insBillId,
					'taxPoint':this.formData.taxPoint,
					'isInvoice':this.formData.isInvoice,
					'receiptType':this.formData.receiptType,
				},
	            "财务补录"
	          );
	          this.dialogVisible = false;
	          this.handleSearch();
	        })
	        .catch(() => {
	          this.$message({
	            type: "info",
	            message: "已取消操作",
	          });
	        });
	    }
	  });
	},
	// 修改服务条款提交
	handleTermSubmit() {
	  this.$refs.baseTermForm.onSubmit((validate) => {
	    if (validate) {
	      this.$confirm("是否确认提交, 是否继续?", "提示", {
	        confirmButtonText: "确定",
	        cancelButtonText: "取消",
	        type: "warning",
	      })
	        .then(async () => {
				const loading = this.$loading({
				  lock: true, // 是否禁止背景滚动，默认为false
				  text: '合同生成中,请耐心等待···', // 加载文本提示，默认为'Loading'
				  spinner: 'el-icon-loading', // 加载图标类型，默认为'el-icon-loading'
				  background: 'rgba(0, 0, 0, 0.7)' // 遮罩层背景颜色，默认为'rgba(0, 0, 0, 0.7)'
				});
	          await this.$api.post(
	            "/admin/carHeTong/saveInsBillTerm",
	            {
					'insBillId':this.termData.insBillId,
					'term':this.termData.term,
				},
	            "修改条款"
	          );
	          this.dialogTermVisible = false;
			  loading.close();
	          this.handleSearch();
	        })
	        .catch(() => {
			  loading.close();
	          this.$message({
	            type: "info",
	            message: "已取消操作",
	          });
	        });
	    }
	  });
	},
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData(1);
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      // console.log(params);
      // const beginTime = this.searchData.dateList[0];
      // const endTime = this.searchData.dateList[1];
      return {
        ...params,
        ...this.searchData,
        // beginTime,
        // endTime,
      };
    },
  },
};
</script>
